import { call } from "redux-saga/effects";
import axios from "axios";

const baseUrl = `${process.env.REACT_APP_GO_API_ENDPOINT}`;

const headers = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const headersUpload = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };
};

const fetcher = {
  post: (url, params, token) => {
    return call(axios.post, `${baseUrl}/${url}`, params, headers(token));
  },
  get: (url, token) => {
    return call(axios.get, `${baseUrl}/${url}`, headers(token));
  },
  patch: (url, params, token) => {
    return call(axios.patch, `${baseUrl}/${url}`, params, headers(token));
  },
  delete: (url, token) => {
    return call(axios.delete, `${baseUrl}/${url}`, headers(token));
  },
  download: (url) => {
    return window.location.assign(`${url}`);
  },
  upload: (url, params, token) => {
    return call(axios.post, `${baseUrl}/${url}`, params, headersUpload(token));
  },
};

const masterData = {
  getCompany: (token, params = {}) =>
    axios.post(`${baseUrl}/masterdata/companies`, params, headers(token)),
  getUsergroup: (token) =>
    axios.post(`${baseUrl}/masterdata/usergroups`, {}, headers(token)),
  getLocations: (params, token) =>
    axios.post(`${baseUrl}/getlocation`, params, headers(token)),
  getPlants: (params, token) =>
    axios.post(`${baseUrl}/masterdata/getplant`, params, headers(token)),
  getUserPlants: (params, token) =>
    axios.post(`${baseUrl}/masterdata/getuserplant`, params, headers(token)),
  getProduct: (params, token) =>
    axios.post(`${baseUrl}/getproduct`, params, headers(token)),
  getProductStructure: (params, token) =>
    axios.post(
      `${baseUrl}/masterdata/getproductstructure`,
      params,
      headers(token)
    ),
  getSubStructure: (params, token) =>
    axios.post(`${baseUrl}/masterdata/getsubstructure`, params, headers(token)),

  getPlantsAutoCompelete: (params, token) =>
    axios.post(`${baseUrl}/autocomplete/plants`, params, headers(token)),
  getPlantSubCompany: (params, token) =>
    axios.post(`${baseUrl}/masterdata/subcompanyplant`, params, headers(token)),
  getDropDownMasterData: (params, token) =>
    axios.post(`${baseUrl}/masterdata/dropdown`, params, headers(token)),
  getDropDownOption: (params, token) =>
    axios.post(`${baseUrl}/masterdata/dropdown-option`, params, headers(token)),
  getDropDownMasterDataWithRelation: (params, token) =>
    axios.post(
      `${baseUrl}/masterdata/dropdownwithrelation`,
      params,
      headers(token)
    ),
  getUserCompanies: (params, token) =>
    axios.post(`${baseUrl}/masterdata/usercompanies`, params, headers(token)),
  getProvinces: (params, token) =>
    axios.get(`${baseUrl}/masterdata/provinces`, headers(token)),
  getBanks: (params, token) =>
    axios.get(`${baseUrl}/masterdata/banks`, headers(token)),
  getAllPlantAccounts: (params, token) =>
    axios.get(`${baseUrl}/plant-accounts/all`, headers(token)),
  getPlantAccountPlants: (params, token) => {
    const queryString = params && Object.keys(params).length > 0
      ? '?' + new URLSearchParams(params).toString()
      : '';
    return axios.get(`${baseUrl}/plant-accounts/plants${queryString}`, headers(token));
  },
  getCompanyHasPlants: (params, token) =>
    axios.post(
      `${baseUrl}/masterdata/company-has-plants`,
      params,
      headers(token)
    ),
  getDistributorDivisionDropDown: (params, token) =>
    axios.post(
      `${baseUrl}/masterdata/distributorDivision`,
      params,
      headers(token)
    ),
  getCustomerPhoneNoDropDownMasterData: (params, token) =>
    axios.post(
      `${baseUrl}/masterdata/getcustomerphonedropdown`,
      params,
      headers(token)
    ),
  getPricelistPlants: (params, token) =>
    axios.post(
      `${baseUrl}/masterdata/getpricelistplants`,
      params,
      headers(token)
    ),
  getSections: (params, token) =>
    axios.get(`${baseUrl}/masterdata/sections`, headers(token)),
};

const getErrorMsg = (error) => {
  const response = error && error.response ? error.response : undefined;

  if (response && typeof response.data !== "undefined" && typeof response.data.message !== "undefined") {
    if (typeof response.data.message === "object") {
      let msg = Object.keys(response.data.message).map(
        (x) => response.data.message[x]
      );
      let errorMsg = "";
      if (typeof msg === "object") {
        msg.map((data) => {
          if (typeof data === "object") {
            errorMsg = Object.keys(data).map((x) => data[x]);
          } else {
            errorMsg += (errorMsg === "" ? "" : " ,") + data;
          }
          return true;
        });
      } else {
        errorMsg = msg;
      }
      return errorMsg;
    }
    return response.data.message;
  }
  return response ? `${error.message} : ${response.statusText}` : error.message;
};

const handleError = (error) => {
  const response = error && error.response ? error.response : undefined;
  if (!response) {
    // Network error or unexpected error shape; log and safely exit
    console.error(error);
    return;
  }
  if (response.status === 401 || response.status === 403) {
    localStorage.clear();
    sessionStorage.clear();
    alert(getErrorMsg(error));
    window.location.href = "/signin";
  }
};

const logErrorMsg = (error) => {
  console.log("errorType", typeof error);
  console.log("error", Object.assign({}, error));
  console.log("getOwnPropertyNames", Object.getOwnPropertyNames(error));
  console.log("stackProperty", Object.getOwnPropertyDescriptor(error, "stack"));
  console.log(
    "messageProperty",
    Object.getOwnPropertyDescriptor(error, "message")
  );
  console.log("stackEnumerable", error.propertyIsEnumerable("stack"));
  console.log("messageEnumerable", error.propertyIsEnumerable("message"));
  console.log("message", error.message);
};

export {
  fetcher,
  masterData,
  logErrorMsg,
  getErrorMsg,
  handleError,
  baseUrl,
  headers,
  headersUpload,
};
